export const validateProductData = (product) => {
    let errors = {};
    const isEmpty = (v) =>
        v === undefined || v === null || (typeof v === 'string' && v.trim() === '');

    // batteryCapacity (required, number)
    if (isEmpty(product?.batteryCapacity)) {
        errors.batteryCapacity = 'Battery capacity is required';
    } else if (!Number.isFinite(Number(product.batteryCapacity))) {
        errors.batteryCapacity = 'Battery capacity must be a valid number';
    }

    // currency (optional, 3-letter code if provided)
    if (!isEmpty(product?.currency)) {
        const cur = String(product.currency).trim();
        if (!/^[A-Za-z]{3}$/.test(cur)) {
            errors.currency = 'Currency must be a 3-letter code';
        }
    }

    // dateOfStorage (required, not empty)
    if (isEmpty(product?.dateOfStorage)) {
        errors.dateOfStorage = 'Date of storage is required';
    }

    // firmwareVersion (required, numbers separated by two dots: X.Y.Z)
    if (isEmpty(product?.firmwareVersion)) {
        errors.firmwareVersion = 'Firmware version is required';
    } else if (!/^\d+\.\d+\.\d+$/.test(String(product.firmwareVersion).trim())) {
        errors.firmwareVersion = 'Firmware version must be in the form X.Y.Z';
    }

    // locationId (required)
    if (isEmpty(product?.locationId)) {
        errors.locationId = 'Location is required';
    }

    // macAddress (required, valid MAC)
    if (isEmpty(product?.macAddress)) {
        errors.macAddress = 'MAC address is required';
    } else if (!/^([0-9A-Fa-f]{2}[:-]){5}[0-9A-Fa-f]{2}$/.test(String(product.macAddress).trim())) {
        errors.macAddress = 'MAC address is invalid';
    }

    // order (required)
    if (isEmpty(product?.order)) {
        errors.order = 'Order is required';
    }

    // price (optional, number if provided; decimals allowed)
    if (!isEmpty(product?.price)) {
        if (!Number.isFinite(Number(product.price))) {
            errors.price = 'Price must be a valid number';
        }
    }

    // serialNumber (required, either: 2-4 chars - 3 digits - 5 digits OR 2-4 chars - 5 digits)
    if (isEmpty(product?.serialNumber)) {
        errors.serialNumber = 'Serial number is required';
    } else if (!/^(?:[A-Za-z0-9]{2,4}-\d{3}-\d{5}|[A-Za-z0-9]{2,4}-\d{5})$/.test(String(product.serialNumber).trim())) {
        errors.serialNumber = 'Serial number is invalid';
    }

    // shelfLife (required, number)
    if (isEmpty(product?.shelfLife)) {
        errors.shelfLife = 'Shelf life is required';
    } else if (!Number.isFinite(Number(product.shelfLife))) {
        errors.shelfLife = 'Shelf life must be a valid number';
    }

    // shelfLifeUnit (required)
    if (isEmpty(product?.shelfLifeUnit)) {
        errors.shelfLifeUnit = 'Shelf life unit is required';
    }

    return errors;
}

export const validateFilesData = (filesData) => {
    const errors = {};
    const isEmpty = (v) =>
        v === undefined || v === null || (typeof v === 'string' && v.trim() === '');

    if (!Array.isArray(filesData)) {
        return errors;
    }

    filesData.forEach((row, index) => {
        const rowErrors = {};

        if (isEmpty(row?.fileName)) {
            rowErrors.fileName = 'File name is required';
        }
        if (isEmpty(row?.issueDate)) {
            rowErrors.issueDate = 'Issue date is required';
        }
        if (isEmpty(row?.expiryDate)) {
            rowErrors.expiryDate = 'Expiry date is required';
        }
        
        if (row?.fileAdded !== true && isEmpty(row?.file)) {
            rowErrors.file = 'File is required';
        }

        if (Object.keys(rowErrors).length > 0) {
            errors[index] = rowErrors;
        }
    });

    return errors;
}

export const validatePartCodeSelection = (partCode) => {
    const errors = {};
    const isEmpty = (v) =>
        v === undefined || v === null || (typeof v === 'string' && v.trim() === '');

    if (!partCode || isEmpty(partCode?._id)) {
        errors.partCode = 'Part code is required';
    }

    return errors;
}